import PricingCard from './PricingCard'

const PricingGrid = ({ plans }) => {
  return (
    <div className="mt-16 flex items-stretch justify-end gap-8">
      {plans.map((plan) => (
        <PricingCard
          key={plan.id}
          {...plan}
        />
      ))}
    </div>
  )
}

export default PricingGrid